export enum LeadFormTypes {
    SINGLE = "Health Single Field Lead form",
    TWO = "Health 2 Field Lead form with OTP [(Mobile, Name) + OTP Validation]",
    THREE = "Health 3 Field Lead form (Mobile, Name, DOB)",
    FIVE = "Health 5 Field Lead form (Mobile, Name, DOB, City, Port)",
    TRAVEL = "Travel Lead Form",
    CORPORATE = "Corporate Lead Form",
}


export const LeadFormNames: Record<LeadFormTypes, string> = {
    [LeadFormTypes.SINGLE]: LeadFormTypes.SINGLE,
    [LeadFormTypes.TWO]: LeadFormTypes.TWO,
    [LeadFormTypes.THREE]: LeadFormTypes.THREE,
    [LeadFormTypes.FIVE]: LeadFormTypes.FIVE,
    [LeadFormTypes.TRAVEL]: LeadFormTypes.TRAVEL,
    [LeadFormTypes.CORPORATE]: LeadFormTypes.CORPORATE,
};
